import { combineReducers } from 'redux';
import { all } from 'redux-saga/effects';
import { loyaltyRewardsReducer, loyaltyRewardsSaga } from './ducks/loyalty-rewards';
import { ratings, rootSaga as ratingsSaga, FETCH_RATINGS, RESET as RATINGS_RESET } from './ducks/rating';
import { ADD_TO_SHOPLIST, REMOVE_FROM_SHOPLIST, rootSaga as shoplistSaga } from './ducks/shoplist';
import {
  rootSaga as productsByIdsSaga,
  productsByIds,
  FETCH_PRODUCTS_BY_IDS,
  RESET as PRODUCTS_BY_ID_RESET,
} from './ducks/products-by-ids';
import {
  rootSaga as sponsoredProductsSaga,
  sponsoredProducts,
  FETCH_SPONSORED_PRODUCTS,
  RESET as SPONSORED_PRODUCTS_RESET,
  isFallback,
  SET_FALLBACK as SPONSORED_PRODUCTS_SET_FALLBACK,
} from './ducks/sponsored-products';

export const products = combineReducers({
  ratings,
  productsByIds,
  sponsoredProducts,
  loyaltyRewards: loyaltyRewardsReducer,
  isFallback,
});

export const productsActions = {
  FETCH_RATINGS,
  RATINGS_RESET,
  ADD_TO_SHOPLIST,
  REMOVE_FROM_SHOPLIST,
  FETCH_PRODUCTS_BY_IDS,
  PRODUCTS_BY_ID_RESET,
  FETCH_SPONSORED_PRODUCTS,
  SPONSORED_PRODUCTS_RESET,
  SPONSORED_PRODUCTS_SET_FALLBACK,
};

export {
  FETCH_RATINGS,
  RATINGS_RESET,
  FETCH_PRODUCTS_BY_IDS,
  FETCH_SPONSORED_PRODUCTS,
  PRODUCTS_BY_ID_RESET,
  SPONSORED_PRODUCTS_RESET,
  SPONSORED_PRODUCTS_SET_FALLBACK,
};

export * from './ducks/selectors';
export * from './components/product';
export * from './types';

export function* productsRootSaga(): unknown {
  return yield all([
    ratingsSaga(),
    shoplistSaga(),
    productsByIdsSaga(),
    sponsoredProductsSaga(),
    loyaltyRewardsSaga(),
  ]);
}
